<template>
  <div class="wallet">
    <mainHeader title="Deposit"></mainHeader>
    <div style="padding: 0 12px;">


    <div class="top-tips" v-html="topTipsHtml"></div>
    <div class="sss">
      <button
        type="button"
        class="btn m-2"
        :class="type === 'USDT' ? 'btn-primary' : 'btn-outline-primary'"
        @click="type = 'USDT'"
      >
        USDT
      </button>
      <button
        type="button"
        class="btn m-2"
        :class="type === 'BTC' ? 'btn-primary' : 'btn-outline-primary'"
        @click="type = 'BTC'"
      >
        BTC
      </button>
       <button
        type="button"
        class="btn m-2"
        :class="type === 'ETH' ? 'btn-primary' : 'btn-outline-primary'"
        @click="type = 'ETH'"
      >
        ETH
      </button>
      <button
        type="button"
        class="btn m-2"
        :class="type === 'Bank' ? 'btn-primary' : 'btn-outline-primary'"
        @click="type = 'Bank'"
      >
        Bank
      </button>
    </div>
    <div class="card position-relative" v-if="type === 'USDT'">
      <LoadingOverlay :show="loading" />
      <div class="card-body">
        <div class="card-title">USDT</div>
        <div class="row">
          <div
            class="col-md-4 col-sm-12 d-flex justify-content-center align-items-center"
          >
            <div
              class="btn-group"
              role="group"
              aria-label="Basic outlined example"
            >
              <button
                v-for="(item, index) in payments"
                :key="index"
                type="button"
                class="btn"
                :class="
                  currentPaymentInd === index
                    ? 'btn-primary'
                    : 'btn-outline-primary'
                "
                @click="showUsdt(index)"
              >
                {{ item.link }}
              </button>
            </div>
          </div>
          <div
            class="col-md-8 col-sm-12 d-flex justify-content-center align-items-center right-qrcode"
          >
            <img :src="qrCode.value" />
          </div>
        </div>
        <div class="input-group mt-3 mb-3 d-flex">
          <input
            style="flex: 1"
            type="text"
            class="form-control"
            readonly
            :value="payments[currentPaymentInd]?.chongbi_addres"
          />
          <button
            class="btn btn-outline-secondary flex-shrink-0"
            type="button"
            @click="copyAddress"
          >
            Copy Address
          </button>
        </div>
        <div class="mb-3">
          <label for="currency" class="form-label">Fill a currency</label>
          <input
            type="number"
            class="form-control"
            id="currency"
            v-model="currency"
          />
        </div>
        <div class="mb-3">
          <label for="currency" class="form-label"
            >Upload payment screenshot</label
          >
          <ImageUploader v-model="screenshotFile" />
        </div>
        <button class="btn btn-primary" type="button" @click="submit">
          Submit
        </button>
      </div>
    </div>
    <div class="card position-relative" v-if="type === 'BTC'">
      <LoadingOverlay :show="loading" />
      <div class="card-body">
        <div class="card-title">BTC</div>
        <div class="row">
          <div
            class="col-md-4 col-sm-12 d-flex justify-content-center align-items-center"
          >
            <div
              class="btn-group"
              role="group"
              aria-label="Basic outlined example"
            >
              <button
                v-for="(item, index) in paymentsBtc"
                :key="index"
                type="button"
                class="btn"
                :class="
                  currentPaymentInd === index
                    ? 'btn-primary'
                    : 'btn-outline-primary'
                "
                @click="showBtc(index)"
              >
                {{ item.link }}
              </button>
            </div>
          </div>
          <div
            class="col-md-8 col-sm-12 d-flex justify-content-center align-items-center right-qrcode"
          >
            <img :src="qrCode.value" />
          </div>
        </div>
        <div class="input-group mt-3 mb-3 d-flex">
          <input
            style="flex: 1"
            type="text"
            class="form-control"
            readonly
            :value="paymentsBtc[currentPaymentInd]?.chongbi_addres"
          />
          <button
            class="btn btn-outline-secondary flex-shrink-0"
            type="button"
            @click="copyAddress"
          >
            Copy Address
          </button>
        </div>
        <div class="mb-3">
          <label for="currency" class="form-label">Fill a currency</label>
          <input
            type="number"
            class="form-control"
            id="currency"
            v-model="currency"
          />
        </div>
        <div class="mb-3">
          <label for="currency" class="form-label"
            >Upload payment screenshot</label
          >
          <ImageUploader v-model="screenshotFile" />
        </div>
        <button class="btn btn-primary" type="button" @click="submit">
          Submit
        </button>
      </div>
    </div>
    <div class="card position-relative" v-if="type === 'ETH'">
      <LoadingOverlay :show="loading" />
      <div class="card-body">
        <div class="card-title">ETH</div>
        <div class="row">
          <div
            class="col-md-4 col-sm-12 d-flex justify-content-center align-items-center"
          >
            <div
              class="btn-group"
              role="group"
              aria-label="Basic outlined example"
            >
              <button
                v-for="(item, index) in paymentsEth"
                :key="index"
                type="button"
                class="btn"
                :class="
                  currentPaymentInd === index
                    ? 'btn-primary'
                    : 'btn-outline-primary'
                "
                @click="showEth(index)"
              >
                {{ item.link }}
              </button>
            </div>
          </div>
          <div
            class="col-md-8 col-sm-12 d-flex justify-content-center align-items-center right-qrcode"
          >
            <img :src="qrCode.value" />
          </div>
        </div>
        <div class="input-group mt-3 mb-3 d-flex">
          <input
            style="flex: 1"
            type="text"
            class="form-control"
            readonly
            :value="paymentsEth[currentPaymentInd]?.chongbi_addres"
          />
          <button
            class="btn btn-outline-secondary flex-shrink-0"
            type="button"
            @click="copyAddress"
          >
            Copy Address
          </button>
        </div>
        <div class="mb-3">
          <label for="currency" class="form-label">Fill a currency</label>
          <input
            type="number"
            class="form-control"
            id="currency"
            v-model="currency"
          />
        </div>
        <div class="mb-3">
          <label for="currency" class="form-label"
            >Upload payment screenshot</label
          >
          <ImageUploader v-model="screenshotFile" />
        </div>
        <button class="btn btn-primary" type="button" @click="submit">
          Submit
        </button>
      </div>
    </div>
    <div class="card position-relative" v-if="type === 'Bank'">
      <LoadingOverlay :show="loading" />
      <div class="card-body">
        <div class="card-title">Bank</div>
        <div class="mb-3">
          <label for="bank" class="form-label">Select bank</label>
          <select id="bank" class="form-select" v-model="bank_id">
            <option v-for="item in banks" :value="item.id" :key="item.id">
              {{ item.bankname }}
            </option>
          </select>
        </div>
        <div class="mb-3">
          <label for="currency" class="form-label">Fill a currency</label>
          <input
            type="number"
            class="form-control"
            id="currency"
            v-model="currency"
          />
        </div>
        <div class="mb-3">
          <label for="currency" class="form-label"
            >Upload payment screenshot</label
          >
          <ImageUploader v-model="screenshotFileBank" />
        </div>
        <button class="btn btn-primary" type="button" @click="submitBank">
          Submit
        </button>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { getPayment, recharge, uploadImg } from "@/apis/wallet";

import LoadingOverlay from "@/components/LoadingOverlay.vue";
import { message } from "@/utils/message";
import { useQRCode } from "@vueuse/integrations/useQRCode";
import ImageUploader from "@/components/ImageUploader.vue";
import mainHeader from '@/components/mainHeader.vue';
export default {
  data() {
    return {
      type: "USDT",
      showUSDT: true,
      loading: false,
      payments: [],
      paymentsBtc: [],
      paymentsEth: [],
      currentPaymentInd: 0,
      screenshotFile: null,
      currency: "",
      banks: [],
      bank_id: "",
      screenshotFileBank: null,
    };
  },

  components: {
    LoadingOverlay,
    ImageUploader,
    mainHeader
  },
  computed: {
    qrCode() {
      if (this.payments.length > 0) {
        return useQRCode(this.payments[this.currentPaymentInd].chongbi_addres);
      }
      return "";
    },
    topTipsHtml() {
      if (this.type === "USDT") {
        return this.payments.length > 0
          ? this.payments[this.currentPaymentInd].html_text || ""
          : "";
      } else {
        return this.banks.length > 0
          ? this.banks.find((item) => item.id === this.bank_id)?.html_text || ""
          : "";
      }
    },
  },
  created() {
    this.showUsdt(0);
    this.showBtc(0);
    this.showEth(0);
    this.getBanks();
  },
  methods: {
    showUsdt(index = 0) {
      this.currentPaymentInd = index;
      this.showUSDT = true;
      this.loading = true;
      this.type = "USDT";

      getPayment({ type: "USDT" })
        .then((res) => {
          console.log(res);
          this.payments = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showBtc(index = 0) {
      this.currentPaymentInd = index;
      this.showBtc = true;
      this.loading = true;
      this.type = "BTC";
      getPayment({ type: "BTC" })
        .then((res) => {
          console.log(res);
          this.paymentsBtc = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showEth(index = 0) {
      this.currentPaymentInd = index;
      this.showEth = true;
      this.loading = true;
      this.type = "ETH";

      getPayment({ type: "ETH" })
        .then((res) => {
          console.log(res);
          this.paymentsEth = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBanks() {
      getPayment({ type: "BANK" }).then((res) => {
        this.banks = res.data;
        this.bank_id = res.data[0].id;
      });
    },
    copyAddress() {
      if (this.type === "USDT") {
        navigator.clipboard.writeText(
          this.payments[this.currentPaymentInd]?.chongbi_addres
        );
      }
      if (this.type === "BTC") {
        navigator.clipboard.writeText(
          this.paymentsBtc[this.currentPaymentInd]?.chongbi_addres
        );
      }
      if (this.type === "ETH") {
        navigator.clipboard.writeText(
          this.paymentsEth[this.currentPaymentInd]?.chongbi_addres
        );
      }
      
      message.success("Copy success");
    },
    async submit() {
      console.log(this.form);
      if (!this.currency || !this.screenshotFile) {
        message.error("Please fill in all fields");
        return;
      }
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append("file", this.screenshotFile);
        const fileRes = await uploadImg(formData);
        console.log(fileRes);
        let params; 
        if (fileRes.code === 0 && fileRes.save_path) {
          if (this.type === "USDT") {
            params = {
              type: 1,
              coin: "USDT",
              link: this.payments[this.currentPaymentInd].link,
              to: this.payments[this.currentPaymentInd].chongbi_addres,
              img: fileRes.save_path,
              amount: this.currency,
            };
          }
          if (this.type === "BTC") {
            params = {
              type: 1,
              coin: "BTC",
              link: this.paymentsBtc[this.currentPaymentInd].link,
              to: this.paymentsBtc[this.currentPaymentInd].chongbi_addres,
              img: fileRes.save_path,
              amount: this.currency,
            };
          }
          if (this.type === "ETH") {
            params = {
              type: 1,
              coin: "ETH",
              link: this.paymentsEth[this.currentPaymentInd].link,
              to: this.paymentsEth[this.currentPaymentInd].chongbi_addres,
              img: fileRes.save_path,
              amount: this.currency,
            };
          }
          
          const res = await recharge(params);
          this.loading = false;
          console.log(res);
          if (res.code === 0) {
            message.success("Recharge successfully");
          }
        } else {
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    },
    async submitBank() {
      if (!this.bank_id || !this.currency || !this.screenshotFileBank) {
        message.error("Please fill in all fields");
        return;
      }
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append("file", this.screenshotFileBank);
        const fileRes = await uploadImg(formData);
        if (fileRes.code === 0 && fileRes.save_path) {
          const params = {
            type: 1,
            coin: "bank",
            bank_id: this.bank_id,
            img: fileRes.save_path,
            amount: this.currency,
          };
          const res = await recharge(params);
          this.loading = false;
          console.log(res);
          if (res.code === 0) {
            message.success("Recharge successfully");
          }
        } else {
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.top-tips {
  padding: 10px;
  color: #999;
  font-size: 14px;
}
.right-qrcode {
  img {
    width: 300px;
    height: 300px;
  }
}
</style>
